import React, { Component } from 'react';
import './ImageViewer.css';
import ParameterErrors from '../errors/ParameterErrors';
import MenuType from '../enums/MenuType';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import SubMenuHeader from './SubMenuHeader';
import Slider from './Slider';
import ZoomableDragable from './ZoomableDragable';
import DynamicImage from '../images/DynamicImage';
import UrlHelper from '../core/UrlHelper';
const  {throwNotProvided, throwNotOfType} = ParameterErrors;
export default class ImageViewer extends Component {
	constructor(props){
		super(props)
		this._iMenuManager  = null;
		this._clickedOffHandle = null;
		this._elementRef = React.createRef();
		this._sliderRef = React.createRef();
		this._pictureWrapperRef=React.createRef();
		this._zoomableDragableRef = React.createRef();
		this._subMenuHeaderRef = React.createRef();
		this.show = this.show.bind(this);
		this.hide= this.hide.bind(this);
		this.load = this.load.bind(this);
		this._handleSliderZoomValueChanged = this._handleSliderZoomValueChanged.bind(this);
		this._getContainerAspectRatio= this._getContainerAspectRatio.bind(this);
		this._updateZoomSlider= this._updateZoomSlider.bind(this);
		this._clickedOffManager = new ClickedOffManager({elementRef:this._elementRef, hide:this.hide});
		this.state={visible:false, url:null, zoom:1};
		this._zoomMin = 1;
		this._zoomMax = 5;
	}
	load(params){
		const{image, rootUrl} = params;
		let url;
		if(image instanceof DynamicImage){
			throw new Error('Not implemented');
		}
		else {
			if(typeof(image)!=='string')
				throw new Error('Not implemented');
			url = image;
		}
		url = (rootUrl?rootUrl:'')+UrlHelper.removeStartSlash(url);
		this._zoomableDragableRef.current.load(url);
		this.show();
		setTimeout(()=>{
			this._zoomableDragableRef.current.setZoom(this._zoomMin);
		},0);
		
	}
	get menuType(){
		return MenuType.IMAGE_VIEWER;
	}
	show(){
		this.setState({visible:true});
		this._clickedOffManager.register();
		this._iMenuManager.showMe(this);
	}
	hide(){
		this._zoomableDragableRef.current.setZoom(this._zoomMin);
		this._clickedOffManager.dispose();
		this.setState({visible:false});
		this._iMenuManager.close();
	}
	setIMenuManager(value){
		this._iMenuManager = value;
		this._subMenuHeaderRef.current.setIMenuManager(value);
	}
	_handleSliderZoomValueChanged(value){
		this._zoomableDragableRef.current.setZoom(value);
	}
	_getContainerAspectRatio(){
		const imageWrapper = this._pictureWrapperRef.current;
		if(imageWrapper===null)return 1;
		return imageWrapper.offsetWidth/imageWrapper.offsetHeight;
	}
	_updateZoomSlider(value){
		this._sliderRef.current.setValue(value);
	}
	render() {
		let className ="image-viewer menu";
		if(this.state.visible)
			className+=" visible";
		const slider = (<div className="slider-wrapper">
					<Slider ref={this._sliderRef} isHorizontal={true} min={this._zoomMin} max={this._zoomMax} initial={this._zoomMin} onValueChanged={this._handleSliderZoomValueChanged}></Slider>
				</div>);
		return (<div className={className} onClick={this._handleClick} ref={this._elementRef}>
				<SubMenuHeader ref={this._subMenuHeaderRef} title={slider}></SubMenuHeader>
				<div className="zoomable-draggable-wrapper" ref={this._pictureWrapperRef}>
					<ZoomableDragable ref={this._zoomableDragableRef} parentElementRef={this._pictureWrapperRef} getContainerAspectRatio={this._getContainerAspectRatio} updateExternalZoomSource={this._updateZoomSlider} zoomMax={this._zoomMax} zoomMin={this._zoomMin}>
					</ZoomableDragable>
				</div>
				</div>);
	}
}
